var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaskGroup12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 318,
    height: 143,
    viewBox: "0 0 318 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    d: "M10,0H308a10,10,0,0,1,10,10V143a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_12",
    "data-name": "Mask Group 12",
    opacity: 0.5,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    d: "M10,0H308a10,10,0,0,1,10,10V129a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    fill: "#1f1b3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(-67.649 -84.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 53.576, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46-2",
    "data-name": "Group 46",
    transform: "translate(0 71)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 33,
    cy: 32.5,
    rx: 33,
    ry: 32.5,
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-bookmark",
    "data-name": "Icon ionic-ios-bookmark",
    d: "M0,2.67V34.38a.334.334,0,0,0,.534.267L10.28,26.97a.676.676,0,0,1,.8,0l9.746,7.677a.334.334,0,0,0,.534-.267V2.67A2.667,2.667,0,0,0,18.692,0H2.67A2.667,2.667,0,0,0,0,2.67Z",
    transform: "translate(22.136 15.143)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(141 140)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2-2",
    "data-name": "Ellipse 2",
    cx: 33,
    cy: 32.5,
    rx: 33,
    ry: 32.5,
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-bookmark-2",
    "data-name": "Icon ionic-ios-bookmark",
    d: "M0,2.67V34.38a.334.334,0,0,0,.534.267L10.28,26.97a.676.676,0,0,1,.8,0l9.746,7.677a.334.334,0,0,0,.534-.267V2.67A2.667,2.667,0,0,0,18.692,0H2.67A2.667,2.667,0,0,0,0,2.67Z",
    transform: "translate(22.502 15.143)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(71)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2-3",
    "data-name": "Ellipse 2",
    cx: 32.5,
    cy: 33,
    rx: 32.5,
    ry: 33,
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-bookmark-3",
    "data-name": "Icon ionic-ios-bookmark",
    d: "M0,2.67V34.38a.334.334,0,0,0,.534.267L10.28,26.97a.676.676,0,0,1,.8,0l9.746,7.677a.334.334,0,0,0,.534-.267V2.67A2.667,2.667,0,0,0,18.692,0H2.67A2.667,2.667,0,0,0,0,2.67Z",
    transform: "translate(21.819 15.46)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(0 141)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2-4",
    "data-name": "Ellipse 2",
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#163e61"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-chatbubbles",
    "data-name": "Icon ionic-ios-chatbubbles",
    transform: "translate(18.576 19.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M25.78,22.331a1.985,1.985,0,0,1,.27-1,2.758,2.758,0,0,1,.172-.254,13.273,13.273,0,0,0,2.261-7.4C28.507,6.127,22.134,0,14.254,0A14.131,14.131,0,0,0,.3,10.887a13.164,13.164,0,0,0-.3,2.8A13.9,13.9,0,0,0,14.008,27.541a16.871,16.871,0,0,0,3.867-.631c.926-.254,1.843-.59,2.081-.68a2.166,2.166,0,0,1,.762-.139,2.13,2.13,0,0,1,.827.164L26.189,27.9a1.108,1.108,0,0,0,.319.082.652.652,0,0,0,.655-.655,1.052,1.052,0,0,0-.041-.221Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(71 71)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2-5",
    "data-name": "Ellipse 2",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#163e61"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-chatbubbles-2",
    "data-name": "Icon ionic-ios-chatbubbles",
    transform: "translate(18.259 18.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5-2",
    "data-name": "Path 5",
    d: "M25.78,22.331a1.985,1.985,0,0,1,.27-1,2.758,2.758,0,0,1,.172-.254,13.273,13.273,0,0,0,2.261-7.4C28.507,6.127,22.134,0,14.254,0A14.131,14.131,0,0,0,.3,10.887a13.164,13.164,0,0,0-.3,2.8A13.9,13.9,0,0,0,14.008,27.541a16.871,16.871,0,0,0,3.867-.631c.926-.254,1.843-.59,2.081-.68a2.166,2.166,0,0,1,.762-.139,2.13,2.13,0,0,1,.827.164L26.189,27.9a1.108,1.108,0,0,0,.319.082.652.652,0,0,0,.655-.655,1.052,1.052,0,0,0-.041-.221Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(141 2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2-6",
    "data-name": "Ellipse 2",
    cx: 33,
    cy: 32.5,
    rx: 33,
    ry: 32.5,
    fill: "#163e61"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-chatbubbles-3",
    "data-name": "Icon ionic-ios-chatbubbles",
    transform: "translate(18.941 18.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5-3",
    "data-name": "Path 5",
    d: "M25.78,22.331a1.985,1.985,0,0,1,.27-1,2.758,2.758,0,0,1,.172-.254,13.273,13.273,0,0,0,2.261-7.4C28.507,6.127,22.134,0,14.254,0A14.131,14.131,0,0,0,.3,10.887a13.164,13.164,0,0,0-.3,2.8A13.9,13.9,0,0,0,14.008,27.541a16.871,16.871,0,0,0,3.867-.631c.926-.254,1.843-.59,2.081-.68a2.166,2.166,0,0,1,.762-.139,2.13,2.13,0,0,1,.827.164L26.189,27.9a1.108,1.108,0,0,0,.319.082.652.652,0,0,0,.655-.655,1.052,1.052,0,0,0-.041-.221Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2-7",
    "data-name": "Ellipse 2",
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#0097fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-user",
    "data-name": "Icon metro-user",
    d: "M17.22,19.461V17.686a9.614,9.614,0,0,0,4.305-8c0-5.35,0-9.686-6.458-9.686S8.61,4.337,8.61,9.686a9.614,9.614,0,0,0,4.305,8v1.775C5.613,20.058,0,23.645,0,27.983H30.136c0-4.338-5.613-7.925-12.915-8.522Z",
    transform: "translate(17.748 18.826)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(71 141)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2-8",
    "data-name": "Ellipse 2",
    cx: 32.5,
    cy: 33,
    rx: 32.5,
    ry: 33,
    fill: "#0097fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-user-2",
    "data-name": "Icon metro-user",
    d: "M17.22,19.461V17.686a9.614,9.614,0,0,0,4.305-8c0-5.35,0-9.686-6.458-9.686S8.61,4.337,8.61,9.686a9.614,9.614,0,0,0,4.305,8v1.775C5.613,20.058,0,23.645,0,27.983H30.136c0-4.338-5.613-7.925-12.915-8.522Z",
    transform: "translate(17.431 19.191)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(141 71)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2-9",
    "data-name": "Ellipse 2",
    cx: 33,
    cy: 32.5,
    rx: 33,
    ry: 32.5,
    fill: "#0097fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-user-3",
    "data-name": "Icon metro-user",
    d: "M17.22,19.461V17.686a9.614,9.614,0,0,0,4.305-8c0-5.35,0-9.686-6.458-9.686S8.61,4.337,8.61,9.686a9.614,9.614,0,0,0,4.305,8v1.775C5.613,20.058,0,23.645,0,27.983H30.136c0-4.338-5.613-7.925-12.915-8.522Z",
    transform: "translate(18.114 18.509)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 258.352, 54.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46-3",
    "data-name": "Group 46",
    transform: "translate(0 71)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2-10",
    "data-name": "Ellipse 2",
    cx: 33,
    cy: 32.5,
    rx: 33,
    ry: 32.5,
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-bookmark-4",
    "data-name": "Icon ionic-ios-bookmark",
    d: "M0,2.67V34.38a.334.334,0,0,0,.534.267L10.28,26.97a.676.676,0,0,1,.8,0l9.746,7.677a.334.334,0,0,0,.534-.267V2.67A2.667,2.667,0,0,0,18.692,0H2.67A2.667,2.667,0,0,0,0,2.67Z",
    transform: "translate(22.136 15.143)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_54-2",
    "data-name": "Group 54",
    transform: "translate(141 140)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2-11",
    "data-name": "Ellipse 2",
    cx: 33,
    cy: 32.5,
    rx: 33,
    ry: 32.5,
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-bookmark-5",
    "data-name": "Icon ionic-ios-bookmark",
    d: "M0,2.67V34.38a.334.334,0,0,0,.534.267L10.28,26.97a.676.676,0,0,1,.8,0l9.746,7.677a.334.334,0,0,0,.534-.267V2.67A2.667,2.667,0,0,0,18.692,0H2.67A2.667,2.667,0,0,0,0,2.67Z",
    transform: "translate(22.502 15.143)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50-2",
    "data-name": "Group 50",
    transform: "translate(71)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2-12",
    "data-name": "Ellipse 2",
    cx: 32.5,
    cy: 33,
    rx: 32.5,
    ry: 33,
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-bookmark-6",
    "data-name": "Icon ionic-ios-bookmark",
    d: "M0,2.67V34.38a.334.334,0,0,0,.534.267L10.28,26.97a.676.676,0,0,1,.8,0l9.746,7.677a.334.334,0,0,0,.534-.267V2.67A2.667,2.667,0,0,0,18.692,0H2.67A2.667,2.667,0,0,0,0,2.67Z",
    transform: "translate(21.819 15.46)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47-2",
    "data-name": "Group 47",
    transform: "translate(0 141)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2-13",
    "data-name": "Ellipse 2",
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#163e61"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-chatbubbles-4",
    "data-name": "Icon ionic-ios-chatbubbles",
    transform: "translate(18.576 19.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5-4",
    "data-name": "Path 5",
    d: "M25.78,22.331a1.985,1.985,0,0,1,.27-1,2.758,2.758,0,0,1,.172-.254,13.273,13.273,0,0,0,2.261-7.4C28.507,6.127,22.134,0,14.254,0A14.131,14.131,0,0,0,.3,10.887a13.164,13.164,0,0,0-.3,2.8A13.9,13.9,0,0,0,14.008,27.541a16.871,16.871,0,0,0,3.867-.631c.926-.254,1.843-.59,2.081-.68a2.166,2.166,0,0,1,.762-.139,2.13,2.13,0,0,1,.827.164L26.189,27.9a1.108,1.108,0,0,0,.319.082.652.652,0,0,0,.655-.655,1.052,1.052,0,0,0-.041-.221Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51-2",
    "data-name": "Group 51",
    transform: "translate(71 71)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2-14",
    "data-name": "Ellipse 2",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#163e61"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-chatbubbles-5",
    "data-name": "Icon ionic-ios-chatbubbles",
    transform: "translate(18.259 18.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5-5",
    "data-name": "Path 5",
    d: "M25.78,22.331a1.985,1.985,0,0,1,.27-1,2.758,2.758,0,0,1,.172-.254,13.273,13.273,0,0,0,2.261-7.4C28.507,6.127,22.134,0,14.254,0A14.131,14.131,0,0,0,.3,10.887a13.164,13.164,0,0,0-.3,2.8A13.9,13.9,0,0,0,14.008,27.541a16.871,16.871,0,0,0,3.867-.631c.926-.254,1.843-.59,2.081-.68a2.166,2.166,0,0,1,.762-.139,2.13,2.13,0,0,1,.827.164L26.189,27.9a1.108,1.108,0,0,0,.319.082.652.652,0,0,0,.655-.655,1.052,1.052,0,0,0-.041-.221Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52-2",
    "data-name": "Group 52",
    transform: "translate(141 2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2-15",
    "data-name": "Ellipse 2",
    cx: 33,
    cy: 32.5,
    rx: 33,
    ry: 32.5,
    fill: "#163e61"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-chatbubbles-6",
    "data-name": "Icon ionic-ios-chatbubbles",
    transform: "translate(18.941 18.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5-6",
    "data-name": "Path 5",
    d: "M25.78,22.331a1.985,1.985,0,0,1,.27-1,2.758,2.758,0,0,1,.172-.254,13.273,13.273,0,0,0,2.261-7.4C28.507,6.127,22.134,0,14.254,0A14.131,14.131,0,0,0,.3,10.887a13.164,13.164,0,0,0-.3,2.8A13.9,13.9,0,0,0,14.008,27.541a16.871,16.871,0,0,0,3.867-.631c.926-.254,1.843-.59,2.081-.68a2.166,2.166,0,0,1,.762-.139,2.13,2.13,0,0,1,.827.164L26.189,27.9a1.108,1.108,0,0,0,.319.082.652.652,0,0,0,.655-.655,1.052,1.052,0,0,0-.041-.221Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48-2",
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2-16",
    "data-name": "Ellipse 2",
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#0097fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-user-4",
    "data-name": "Icon metro-user",
    d: "M17.22,19.461V17.686a9.614,9.614,0,0,0,4.305-8c0-5.35,0-9.686-6.458-9.686S8.61,4.337,8.61,9.686a9.614,9.614,0,0,0,4.305,8v1.775C5.613,20.058,0,23.645,0,27.983H30.136c0-4.338-5.613-7.925-12.915-8.522Z",
    transform: "translate(17.748 18.826)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_49-2",
    "data-name": "Group 49",
    transform: "translate(71 141)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2-17",
    "data-name": "Ellipse 2",
    cx: 32.5,
    cy: 33,
    rx: 32.5,
    ry: 33,
    fill: "#0097fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-user-5",
    "data-name": "Icon metro-user",
    d: "M17.22,19.461V17.686a9.614,9.614,0,0,0,4.305-8c0-5.35,0-9.686-6.458-9.686S8.61,4.337,8.61,9.686a9.614,9.614,0,0,0,4.305,8v1.775C5.613,20.058,0,23.645,0,27.983H30.136c0-4.338-5.613-7.925-12.915-8.522Z",
    transform: "translate(17.431 19.191)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53-2",
    "data-name": "Group 53",
    transform: "translate(141 71)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2-18",
    "data-name": "Ellipse 2",
    cx: 33,
    cy: 32.5,
    rx: 33,
    ry: 32.5,
    fill: "#0097fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-user-6",
    "data-name": "Icon metro-user",
    d: "M17.22,19.461V17.686a9.614,9.614,0,0,0,4.305-8c0-5.35,0-9.686-6.458-9.686S8.61,4.337,8.61,9.686a9.614,9.614,0,0,0,4.305,8v1.775C5.613,20.058,0,23.645,0,27.983H30.136c0-4.338-5.613-7.925-12.915-8.522Z",
    transform: "translate(18.114 18.509)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    d: "M10,0H308a10,10,0,0,1,10,10V143a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    fill: "#17142d",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskGroup12);
export default __webpack_public_path__ + "static/media/Mask Group 12.2882a2da07949d831633e34597117584.svg";
export { ForwardRef as ReactComponent };